import React, {useEffect} from 'react';
import MaterialTable, { MTableActions } from "material-table";
import { useTranslation } from 'react-i18next';
import { CircularProgress, MuiThemeProvider } from '@material-ui/core';
import { useStores } from '../../../_stores';
import { autorun } from 'mobx';
import { observer, useLocalStore } from 'mobx-react-lite';
import { Notification } from '../../../core/Notification';
import { SecureStyles } from '../Styles/SecureStyles';
import { LicenseImport } from '../../../core/LicenseImport';


const TableLicense = observer(() => {
    const classes = SecureStyles();
    const {secureStore, importStore} = useStores();
    
    const materialTableRef = React.createRef<any>();

    const state = useLocalStore(() => ({
        isOpen: false,
        isImportLicense: false,
    }));

    const {t} = useTranslation();
    const translate = (variable: string) => {
        return t('updates.' + variable);
    };

    useEffect(() => {
        autorun(async () => {
            await secureStore.loadSecureInfo();
        });
    }, []);

    const getComponents = () => {
        if(secureStore.loadStatus)
            return {
                Actions: (props: any) => <div><CircularProgress/></div>,
            }

        return {
            Actions: (props: any) => {
                return <MTableActions {...props} /> 
            },
        }
    }

    return (
        <div>
            {
                secureStore.isLoading &&
                <div className={classes.loading}> <CircularProgress disableShrink/> </div>
            }
            <MaterialTable
                localization={t('tables', {returnObjects: true})}
                title={'Лицензии'}
                columns={[
                    {field: 'ServiceName', title: "Имя сервиса"},
                    {field: 'ValidUntil', title: "Дата окончания лицензии",},
                ]}
                data={secureStore.licenseServices}
                options={{
                    search: false,
                    paging: false,
                }}
                actions={[
                    {
                        icon: 'cloud_upload',
                        tooltip: 'Импорт файла лицензии',
                        isFreeAction: true,
                        onClick: () => state.isImportLicense = true,
                    },
                ]}
                components={getComponents()}
                tableRef={materialTableRef}
            />
            <LicenseImport 
                isOpen={state.isImportLicense}
                isLoading={importStore.loading}
                close={() => state.isImportLicense = false}
                save={async (files) => {
                    await secureStore.importSecureFile(files);
                }}
            />
            <Notification
                isOpen={secureStore.isNotification}
                close={() => secureStore.isNotification = false}
                okClick={() => secureStore.isNotification = false}
                questionText={secureStore.message}
            />
        </div>
    )
});

export default TableLicense;

